export const BLACK_01 = `#191919`;
export const WHITE_01 = `#FFFFFF`;
export const BLUE_01 = `#4A90F7`;
export const GREY_01 = `#F1F2F6`;
export const GREY_02 = `#C4C4C4`;
export const YELLOW_01 = `#F8F662`;

export const getColor = (color) => {
	if(color){
		switch(color.toLowerCase()){
			case 'blue':
			return BLUE_01;
			case 'yellow':
			return YELLOW_01;
			case 'black':
			return BLACK_01;
			case 'grey':
			return GREY_01;
			case 'dark grey':
			return GREY_02;
		}
	}

	return WHITE_01;
}